import moment from "moment";

const useRelativeTime = (inputDate: string) => {
	if (!inputDate) return "";

	let result = "";

	try {
		// Remove microseconds if present
		const cleanedDate = inputDate.split(".")[0];

		// Convert to local time
		const localTime = moment.utc(cleanedDate).local();

		const now = moment();
		const isToday = localTime.isSame(now, "day");

		if (isToday) {
			// Example: 13:56 (4 hours ago)
			result = `${localTime.format("HH:mm")} (${localTime.fromNow()})`;
		} else {
			// Example: Thu 8 May, 12:23 (1 day ago)
			result = `${localTime.format("ddd D MMM, HH:mm")} (${localTime.fromNow()})`;
		}
	} catch (error) {
		console.error("Error parsing date:", error);
		result = "Invalid date";
	}

	return result;
};

export default useRelativeTime;
